// Calls an action when number type input is scrolling
const preventNumberScroll = {
  // eslint-disable-next-line no-unused-vars
  beforeMount(el, binding, vnode, prevVnode) {
    el.numberChangeActionKeyboard = event => {
      // here I check that keyvboard arrow was number type the el and his children
      const arrowKeys = ['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown']
      // Turn off the keypress to change input type number-value feature by modifying the input element's behavior
      if (arrowKeys.includes(event.code) && el.type === 'number') {
        el.blur()
        event.preventDefault()
      } else if (typeof binding.value === 'function') {
        binding.value(event)
      }
    }
    el.numberChangeActionWheel = event => {
      // here I check that wheel was number type the el and his children
      if (el.type === 'number') {
        // Turn off the scroll to change input type number-value feature by modifying the input element's behavior
        el.blur()
        event.preventDefault()
      }
    }
    el.addEventListener('keydown', el.numberChangeActionKeyboard, { passive: false })
    el.addEventListener('wheel', el.numberChangeActionWheel, { passive: false })
  },
  // eslint-disable-next-line no-unused-vars
  unmounted(el, binding, vnode, prevVnode) {
    // when the directive is removed from the element, remove the keyboard listener
    el.removeEventListener('keydown', el.numberChangeActionKeyboard)
    // when the directive is removed from the element, remove the wheel listener
    el.removeEventListener('wheel', el.numberChangeActionWheel)
  }
}

export default preventNumberScroll
